import FDictionary from '@/modules/Dictionary/__select';
import core from '@/core';

export default class FPartnerLegal extends FDictionary {
  dictionary = 'partnerLegal';

  constructor(props) {
    super(props);
    if (props.partner) {
      this.partner = props.partner;
    }
    this.isMyAgency = !!props.isMyAgency;
  }

  get partner() {
    return this.refs.data.partner;
  }

  set partner(value) {
    if (!value) {
      return;
    }
    this.refs.data.partner = value;
    this.refs.set('partner', value);
  }

  getOptions(model) {
    if (this.isMyAgency) {
      return super.getOptions({
        partner: core.account.partner,
      });
    }
    if (!model.partner) {
      return Promise.resolve(this.setOptions([]));
    }
    return super.getOptions(model);
  }

  setOptions(options = []) {
    this.options = options;
    if (this.value && !this.options.find(i => i.value === this.value.value)) {
      this.value = null;
    }
  }
}
